import { memo } from 'react';

import PropTypes from 'prop-types';

import useIsMobile from '../utilities/useIsMobile';
import DesktopNavigations from './components/DesktopNavigations';
import Navigations from './components/Navigations';
import useGlobalNav from './customHooks/useGlobalNav';

import './styles/index.css';

function GlobalNav({ navigationData, pathname, handleGlobalNavigation, isGlobalNavExpanded, loaderNavLabel }) {
  const { navItemForDisplay, tabHistory, handleParentNav, handleChildNav, activeTabName, setHostName } =
    useGlobalNav(navigationData);
  const { isMobile } = useIsMobile();
  const renderNavigation = () =>
    isMobile ? (
      <nav
        role="presentation"
        className={`global-nav__content ${isGlobalNavExpanded ? 'global-nav__content--active' : ''}`}
      >
        <Navigations
          navItems={navItemForDisplay}
          pathname={pathname}
          tabs={tabHistory}
          handleChildNav={handleChildNav}
          handleParentNav={handleParentNav}
          activeTabName={activeTabName}
          setHostName={setHostName}
          loaderNavLabel={loaderNavLabel}
        />
      </nav>
    ) : (
      <nav
        role="presentation"
        className={`global-nav__desktop-content ${isGlobalNavExpanded ? 'global-nav__desktop-content--active' : ''}`}
        onClick={handleGlobalNavigation}
        onKeyUp={handleGlobalNavigation}
      >
        <DesktopNavigations
          navItems={navItemForDisplay}
          pathname={pathname}
          childClass="parent-menu"
          activeTabName={activeTabName}
          setHostName={setHostName}
          loaderNavLabel={loaderNavLabel}
        />
      </nav>
    );
  return navItemForDisplay && navItemForDisplay.length && renderNavigation();
}

GlobalNav.propTypes = {
  navigationData: PropTypes.instanceOf(Array).isRequired,
  isGlobalNavExpanded: PropTypes.bool.isRequired,
  loaderNavLabel: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  handleGlobalNavigation: PropTypes.func
};

GlobalNav.defaultProps = {
  handleGlobalNavigation: () => {}
};

function areEqual(prevProps, nextProps) {
  return (
    JSON.stringify(prevProps.navigationData) === JSON.stringify(nextProps.navigationData) &&
    prevProps.pathname === nextProps.pathname &&
    prevProps.isGlobalNavExpanded === nextProps.isGlobalNavExpanded
  );
}
export default memo(GlobalNav, areEqual);
